// Integration.jsx
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppList from "../component/Integration/AppList.jsx";

const Integration = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const typeParam = searchParams.get("type") || "all";
  const [type, setType] = useState(typeParam);
  const [category, setCategory] = useState("All");

  useEffect(() => {
    setType(typeParam);
  }, [typeParam]);

  const handleTabClick = (value) => {
    setSearchParams({ type: value });
  };

  const categories = ["All", "Payment", "Finance", "Automation"];

  return (
    <div className="container-fluid py-4">
      <h5 className="fw-bold mb-3">Integrations</h5>
      <p className="text-muted mb-4">Connect Interakt with various applications</p>

      {/* Tabs + Dropdown */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex gap-3 border-bottom pb-2">
          {["all", "free", "paid", "my"].map((tab) => (
            <button
              key={tab}
              onClick={() => handleTabClick(tab)}
              className={`btn btn-link text-decoration-none px-2 py-1 ${
                type === tab ? "border-bottom border-success fw-bold text-success" : "text-secondary"
              }`}
            >
              {tab.charAt(0).toUpperCase() + tab.slice(1)} Apps
            </button>
          ))}
        </div>

        {/* Dropdown */}
        <div>
          <select
            className="form-select w-auto"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            {categories.map((cat, index) => (
              <option key={index} value={cat}>
                {cat} Category
              </option>
            ))}
          </select>
        </div>
      </div>

      <AppList type={type} category={category} />
    </div>
  );
};

export default Integration;
